import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=50b0736c&scoped=true&"
import script from "./SelectProduct.vue?vue&type=script&lang=js&"
export * from "./SelectProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectProduct.vue?vue&type=style&index=0&id=50b0736c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0736c",
  null
  
)

export default component.exports